export default __webpack_public_path__ + "static/man-1eb0af0b24e922856e082c28c04b4c3d.png";